/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateOrganizationRequest
 */
export interface CreateOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    orgType: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    address?: string | null;
    /**
     * Must be a fully-qualified URL starting with http:// or https://
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    website?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    notes?: string | null;
}

/**
 * Check if a given object implements the CreateOrganizationRequest interface.
 */
export function instanceOfCreateOrganizationRequest(value: object): value is CreateOrganizationRequest {
    if (!('orgType' in value) || value['orgType'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateOrganizationRequestFromJSON(json: any): CreateOrganizationRequest {
    return CreateOrganizationRequestFromJSONTyped(json, false);
}

export function CreateOrganizationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrganizationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'orgType': json['orgType'],
        'name': json['name'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'email': json['email'] == null ? undefined : json['email'],
        'address': json['address'] == null ? undefined : json['address'],
        'website': json['website'] == null ? undefined : json['website'],
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function CreateOrganizationRequestToJSON(json: any): CreateOrganizationRequest {
    return CreateOrganizationRequestToJSONTyped(json, false);
}

export function CreateOrganizationRequestToJSONTyped(value?: CreateOrganizationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orgType': value['orgType'],
        'name': value['name'],
        'phone': value['phone'],
        'email': value['email'],
        'address': value['address'],
        'website': value['website'],
        'notes': value['notes'],
    };
}

